module.exports = __webpack_public_path__ + "img/navbar.1c429b18.jpg";